/**
 * 港澳台id列表
 */
export var specialAreaIds = ['810000', '820000', '710000'];